import { compose, max } from 'ramda';
import { curry, flatMap, mapValues, map, isArray, isFunction, isObject, toNumber as toNumberFunction } from 'lodash';

const evolve = curry((transformations, item) => {
    if (isArray(item)) {
        return map(item, evolve(transformations));
    }

    return mapValues(item, (value, key) => {
        const transformation = transformations[key];
        if (isFunction(transformation)) {
            if (isArray(value)) {
                return flatMap(value, (val) => transformation(val, item));
            }
            return transformation(value, item);
        } else if (isObject(transformation)) {
            return evolve(transformation, value);
        }
        return value;
    });
});

export default evolve;

export const toNumber = value => value ? toNumberFunction(value) : undefined;
export const toCode = compose(toNumber, max(0));
